import React, { useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const mockLogs = Array.from({ length: 36 }, (_, i) => ({
  message: [
    "Lead Added – Rajesh Sharma (Health Insurance)",
    "Invoice Accepted – Policy #IC12345",
    "Payment Received – ₹20,000",
    "Lead Added – Priya Mehta (Car Insurance)",
    "Invoice Accepted – Policy #IC56789",
    "Lead Added – Amit Verma (Loan)",
    "Application Approved",
    "Registered as an Advisor on StarFor",
  ][i % 8],
  timestamp: "12 Jan 2025, 10:05 AM",
}));

const ITEMS_PER_PAGE = 6;

const AdvisorlogTab = () => {
  const [page, setPage] = useState(1);

  const totalPages = Math.ceil(mockLogs.length / ITEMS_PER_PAGE);
  const paginatedLogs = mockLogs.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  return (
    <div className="bg-white shadow rounded-md p-4 w-full  mx-auto">
      {paginatedLogs.map((log, idx) => (
        <div
          key={idx}
          className="flex justify-between py-1 text-sm text-gray-800 border-b border-gray-100 last:border-none w-full"
        >
          <span>{log.message}</span>
          <span className="text-gray-500 whitespace-nowrap">{log.timestamp}</span>
        </div>
      ))}

      <div className="flex justify-between items-center pt-4 text-sm text-gray-600">
        <span>
          {ITEMS_PER_PAGE * (page - 1) + 1}-
          {Math.min(ITEMS_PER_PAGE * page, mockLogs.length)} of {mockLogs.length}
        </span>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setPage((p) => Math.max(p - 1, 1))}
            disabled={page === 1}
            className="p-1 disabled:opacity-50"
          >
            <FiChevronLeft size={18} />
          </button>
          <button
            onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
            disabled={page === totalPages}
            className="p-1 disabled:opacity-50"
          >
            <FiChevronRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdvisorlogTab;
